/* SEXYSHOES | Searchanise Desktop Hover Quick Add v2
   - Desktop only
   - Opens existing Quick Add on hover
   - Keeps open while hovering Quick Add or size panel
   - Closes when mouse leaves both areas
*/

(function () {
  var OPEN_DELAY = 150;
  var CLOSE_DELAY = 120;

  function isDesktop() {
    return window.matchMedia('(min-width: 769px)').matches;
  }

  function getQuickAdd(el) {
    var target = el.closest('button, [role="button"]');
    if (!target) return null;

    var text = (target.textContent || '').trim().toLowerCase();
    if (text.indexOf('quick add') === -1) return null;

    return target;
  }

  function getCard(el) {
    return el.closest('.snize-product');
  }

  function getSizePanel(card) {
    return card ? card.querySelector('.ss-desktop-size-panel') : null;
  }

  function isInsideActiveArea(card, el) {
    if (!card || !el) return false;

    var quickAdd = card.querySelector('.ss-desktop-quickadd-trigger');
    var panel = getSizePanel(card);

    return (
      (quickAdd && quickAdd.contains(el)) ||
      (panel && panel.contains(el))
    );
  }

  function clearOpenTimer(button) {
    if (button && button.ssHoverOpenTimer) {
      clearTimeout(button.ssHoverOpenTimer);
      button.ssHoverOpenTimer = null;
    }
  }

  function clearCloseTimer(card) {
    if (card && card.ssHoverCloseTimer) {
      clearTimeout(card.ssHoverCloseTimer);
      card.ssHoverCloseTimer = null;
    }
  }

  function openPanel(button) {
    if (!button || !document.body.contains(button)) return;

    var card = getCard(button);
    if (!card) return;

    clearCloseTimer(card);

    if (!card.classList.contains('ss-desktop-quickadd-open')) {
      button.click();
    }
  }

  function closePanel(card) {
    if (!card || !document.body.contains(card)) return;

    var closeButton = card.querySelector('.ss-desktop-quickadd-trigger');

    if (card.classList.contains('ss-desktop-quickadd-open') && closeButton) {
      closeButton.click();
    }
  }

  document.addEventListener('mouseover', function (event) {
    if (!isDesktop()) return;

    var button = getQuickAdd(event.target);
    if (!button) return;

    var card = getCard(button);
    if (!card) return;

    clearOpenTimer(button);
    clearCloseTimer(card);

    button.ssHoverOpenTimer = setTimeout(function () {
      openPanel(button);
    }, OPEN_DELAY);
  }, true);

  document.addEventListener('mouseout', function (event) {
    if (!isDesktop()) return;

    var card = getCard(event.target);
    if (!card) return;

    var related = event.relatedTarget;

    if (isInsideActiveArea(card, related)) {
      return;
    }

    var button = card.querySelector('.ss-desktop-quickadd-trigger');
    clearOpenTimer(button);
    clearCloseTimer(card);

    card.ssHoverCloseTimer = setTimeout(function () {
      var currentHover = document.querySelector(':hover');
      if (!isInsideActiveArea(card, currentHover)) {
        closePanel(card);
      }
    }, CLOSE_DELAY);
  }, true);
})();